'use strict';
var userAgent = require('../internals/environment-user-agent');

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/declarative-type-validator/node_modules/core-js/internals/environment-is-ios-pebble.js
// module id = 5489
// module chunks = 25